import { FieldError } from "react-hook-form";

const StandardErrorMessage = {
  required: "Field is required",
  maxLength: "Field is too long",
};

export const ErrorMessage = ({
  error,
  errorMessage,
}: {
  error?: FieldError;
  errorMessage?: string;
}) => (
  <span className="text-xs font-regular leading-normal text-destructive">
    {error?.message ||
      StandardErrorMessage[error?.type as keyof typeof StandardErrorMessage] ||
      errorMessage ||
      "There is an error"}
  </span>
);
